// Supplemental display attributes, including financial/statistical context.
export const attributeArabicTranslations: Record<string, string> = {
  'Complete student history. Receipt ownership is shown for this history, independently of the selected report month.': 'ده تاريخ العميل الكامل. إسناد التحصيلات معروض لهذا التاريخ، بشكل مستقل عن شهر التقرير المختار.',
  'Finance summary could not be loaded. Available invoice details are shown below.': 'تعذّر تحميل ملخص الحسابات. تفاصيل الفواتير المتاحة ظاهرة بالأسفل.',
  'Invoice details could not be loaded. Available summary figures remain visible.': 'تعذّر تحميل تفاصيل الفواتير. أرقام الملخص المتاحة ما زالت ظاهرة.',
  'Today’s income components': 'مكونات إيراد اليوم',
  'Daily totals only. Use the full finance report to compare a month with Accounting.': 'الإجماليات تخص اليوم فقط. استخدم تقرير الحسابات الكامل لمقارنة شهر مع قسم الحسابات.',
  'Sales team collections': 'تحصيلات فريق المبيعات',
  'Recorded attribution outside the sales team': 'إسناد مسجّل خارج فريق المبيعات',
  'Cash receipt components': 'مكونات التحصيلات',
  'All cash receipts': 'إجمالي التحصيلات من كل المصادر',
  'Same period and branch. Includes student payments and other collected income.': 'لنفس الفترة والفرع، ويشمل مدفوعات الطلاب والإيرادات الأخرى المحصّلة.',
  'Student invoice receipts': 'تحصيلات فواتير الطلاب',
  'Other collected income': 'إيرادات أخرى محصّلة',
  'Placement payments': 'مدفوعات تحديد المستوى',
  '{0} receipt records': '{0} حركة تحصيل',
  'Student payments collected': 'تحصيلات مدفوعات الطلاب',
  'Student payment records': 'حركات مدفوعات الطلاب',
  '{0} student payment records': '{0} حركة من مدفوعات الطلاب',
  'This view covers student invoice and placement receipts. Other collected income appears in the full finance report.': 'العرض ده يشمل تحصيلات فواتير الطلاب وتحديد المستوى. الإيرادات الأخرى المحصّلة موجودة في تقرير الحسابات الكامل.',
  'Breakdowns below cover student invoice and placement receipts only. Source identifies the original sale owner, not the person who received the payment.': 'التقسيمات التالية تخص تحصيلات فواتير الطلاب وتحديد المستوى فقط. المصدر يوضح صاحب البيع الأصلي، وليس الموظف الذي استلم الدفع.',
  'Total revenue includes student invoice receipts, placement payments and other collected income. Student payment records exclude other income entries.': 'إجمالي الإيراد يشمل تحصيلات فواتير الطلاب وتحديد المستوى والإيرادات الأخرى المحصّلة. عدد حركات مدفوعات الطلاب لا يشمل سجلات الإيرادات الأخرى.',
  "Across visible history": "في السجل الظاهر",
  "Active": "نشط",
  "All available records": "كل السجلات المتاحة",
  "All configured slots": "كل المواعيد المسجلة",
  "All inquiries": "كل الاستفسارات",
  "All reports in this view": "كل التقارير في العرض ده",
  "Approved excuses": "الأعذار المقبولة",
  "Approved expenses": "المصروفات المعتمدة",
  "Paid expenses": "المصروفات المدفوعة",
  "Collected": "مُحصّل",
  "Collected income": "الإيرادات المحصّلة",
  "Enter money already collected. It counts in today's closing immediately.": "اكتب الفلوس اللي اتحصّلت فعلًا. بتتحسب فورًا في تقفيلة النهارده.",
  "Approved expenses last {0} days": "المصروفات المعتمدة في آخر {0} يوم",
  "Approved expenses today": "المصروفات المعتمدة النهارده",
  "Approved income": "الإيرادات المعتمدة",
  "Approved income last {0} days": "الإيرادات المعتمدة في آخر {0} يوم",
  "Approved income minus expenses": "الإيرادات المعتمدة ناقص المصروفات",
  "Approved income today": "الإيرادات المعتمدة النهارده",
  "Approved paid entries": "السجلات المدفوعة المعتمدة",
  "Assign student levels": "تحديد مستويات الطلاب",
  "Assigned to you": "متعيّنة ليك",
  "Auto-updates": "تحديثات تلقائية",
  "Bookable by leads": "متاح للحجز للعملاء المحتملين",
  "Branch report": "تقرير الفرع",
  "Change the search term or clear the search box.": "غيّر كلمة البحث أو امسح البحث.",
  "Completed groups": "المجموعات اللي خلصت",
  "Completed reviews": "المراجعات اللي خلصت",
  "Confirmed by phone": "متأكد بالتليفون",
  "Cost centers": "مراكز التكلفة",
  "Could not load data": "ما قدرناش نحمّل البيانات",
  "Course + branch + month": "الكورس + الفرع + الشهر",
  "Course payments only": "مدفوعات الكورس بس",
  "Create Exam": "إنشاء امتحان",
  "Create a coupon after adding program university and faculty options.": "اعمل كوبون بعد إضافة اختيارات الجامعة والكلية للبرنامج.",
  "Create a group session, then mark present, absent, or late for summer submissions.": "اعمل حصة للمجموعة، وبعدها سجّل المتدربين حاضر أو غايب أو متأخر.",
  "Create a summer program before publishing a registration form.": "اعمل برنامج تدريب صيفي قبل نشر نموذج التسجيل.",
  "Create and publish a form to open public registration links.": "اعمل نموذج وانشره عشان تفتح لينكات التسجيل العامة.",
  "Create groups after verifying registrations.": "اعمل المجموعات بعد التحقق من التسجيلات.",
  "Create your first placement exam and publish it when ready.": "اعمل أول امتحان تحديد مستوى وانشره لما يبقى جاهز.",
  "Currently active": "نشط حاليًا",
  "Demand distribution by week start.": "توزيع الطلب حسب بداية الأسبوع.",
  "Demand entries": "سجلات الطلب",
  "Error Loading Groups": "حصل خطأ في تحميل المجموعات",
  "Failed to load waiting insights": "ما قدرناش نحمّل تحليلات الانتظار",
  "Filtered records": "السجلات بعد الفلترة",
  "Generate from file": "إنشاء من ملف",
  "In this session": "في الحصة دي",
  "Income minus expenses": "الإيرادات ناقص المصروفات",
  "Income {0} / Expenses {1}": "الإيرادات {0} / المصروفات {1}",
  "Invoice exists": "فيه فاتورة",
  "Late records": "السجلات المتأخرة",
  "Leave enough time for all sections.": "سيب وقت كفاية لكل الأقسام.",
  "Live": "مباشر",
  "Loading live data": "جاري تحميل البيانات المباشرة",
  "Manual exam builder": "إنشاء الامتحان يدويًا",
  "Marked attendance": "الحضور المسجل",
  "Marked present": "متسجل حاضر",
  "Need action": "محتاج إجراء",
  "Need action first": "محتاج إجراء الأول",
  "Need attention": "محتاج اهتمام",
  "Need creation": "محتاج إنشاء",
  "Need follow-up": "محتاج متابعة",
  "Needs action": "محتاج إجراء",
  "Needs follow-up": "محتاج متابعة",
  "Needs group/installments": "محتاج مجموعة / أقساط",
  "New submissions will appear here as soon as students complete exams.": "المحاولات الجديدة هتظهر هنا أول ما الطلاب يخلصوا الامتحانات.",
  "No attendance matrix data found for this group.": "مفيش بيانات جدول حضور للمجموعة دي.",
  "No branch data": "مفيش بيانات فروع",
  "No cost center data": "مفيش بيانات مراكز تكلفة",
  "No daily data": "مفيش بيانات يومية",
  "No expenses": "مفيش مصروفات",
  "No level exam attempts yet": "مفيش محاولات امتحان مستوى لسه",
  "No metadata available.": "مفيش بيانات إضافية متاحة.",
  "No placement attempts yet": "مفيش محاولات تحديد مستوى لسه",
  "No recorded activity": "مفيش نشاط مسجل",
  "No session data found.": "مفيش بيانات للحصة.",
  "No subject snapshot available.": "مفيش بيانات محفوظة للموضوع.",
  "Only showing logs that require immediate approval. Other logs will be visible once all pending danger actions are resolved.": "الظاهر دلوقتي السجلات اللي محتاجة موافقة فورية بس. باقي السجلات هتظهر بعد حل كل إجراءات الخطر المعلّقة.",
  "Optional same-origin /hooks/ or /api/hooks/ path; query strings and credentials are rejected.": "مسار اختياري /hooks/ أو /api/hooks/ على نفس الموقع؛ روابط الاستعلام وبيانات الدخول مش مقبولة.",
  "Optional single student practice import.": "استيراد تدريبي اختياري لطالب واحد.",
  "Paying students": "الطلاب الدافعين",
  "Payments recorded here produce summer receipts and never touch core academy invoices.": "الدفعات هنا بتصدر إيصالات تدريب صيفي ومش بتغيّر فواتير الأكاديمية الأساسية.",
  "Per transaction": "لكل معاملة",
  "Published public forms will feed this workspace as soon as students submit them.": "التسجيلات هتظهر هنا أول ما الطلاب يبعتوا النماذج العامة المنشورة.",
  "Queue after approval": "الطابور بعد الموافقة",
  "Reception users": "موظفين الريسبشن",
  "Refresh the page after confirming the backend is running.": "حدّث الصفحة بعد ما تتأكد إن السيرفر شغّال.",
  "Remote consults": "استشارات عن بُعد",
  "Search group code or course...": "ابحث بكود المجموعة أو الكورس...",
  "Separate student services": "خدمات الطلاب منفصلة",
  "Single student selected for practice import.": "طالب واحد محدد للاستيراد التدريبي.",
  "Slot chosen": "الميعاد اتحدد",
  "Students grouped by target month.": "الطلاب متجمعين حسب الشهر المستهدف.",
  "Students will appear here after submitting a published summer training form.": "الطلاب هتظهر هنا بعد إرسال نموذج تدريب صيفي منشور.",
  "Task monitoring": "متابعة المهام",
  "Team report": "تقرير الفريق",
  "The group ID provided is not valid.": "رقم المجموعة مش صحيح.",
  "The live summary has no sessions for today.": "الملخص المباشر مفيهوش حصص للنهارده.",
  "The session ID provided is not valid.": "رقم الحصة مش صحيح.",
  "There are no live sessions in today's reception summary.": "مفيش حصص مباشرة في ملخص الريسبشن النهارده.",
  "There are no undone assigned tasks in the live summary.": "مفيش مهام متعيّنة غير مكتملة في الملخص المباشر.",
  "Try another branch or clear the branch filter.": "جرّب فرع تاني أو امسح فلتر الفرع.",
  "Try another status or clear the search.": "جرّب حالة تانية أو امسح البحث.",
  "Upcoming groups": "المجموعات الجاية",
  "Upload and organize": "رفع وتنظيم",
  "View Exams": "عرض الامتحانات",
  "View absent students": "عرض الطلاب الغايبين",
  "View categories": "عرض التصنيفات",
  "Visible records": "السجلات الظاهرة",
  "Waiting for follow-up": "مستني متابعة",
  "Waiting for the latest calendar data.": "مستني أحدث بيانات التقويم.",
  "Waiting for the latest reception data.": "مستني أحدث بيانات الريسبشن.",
  "drag handle": "مقبض تغيير الترتيب",
  "{0} absence": "{0} غياب",
  "{0} attendance": "{0} حضور",
  "{0} excused": "{0} بعذر",
  "{0} income and {1} expenses": "{0} إيرادات و{1} مصروفات",
  "{0} late": "{0} متأخر",
  "{0} transactions": "{0} معاملات",
  "{0} upcoming": "{0} جاي",
  "{0} upcoming sessions": "{0} حصص جاية",
  "{0}% finished": "{0}% مكتمل",
  "{0}% of total": "{0}% من الإجمالي",
  "{0}/{1}": "{0}/{1}"
};

